document.addEventListener('DOMContentLoaded', () => {
    const scrollToTopButton = document.getElementById('scrollToTop');

    scrollToTopButton.addEventListener('click', () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
});

// Yotpo Reviews Carousel on PDP
// ---------------------

function waitForAssertion(assertionPredicateFn, { totalWaitingTime = 20000, totalAttempts = 20, debugLabel = null } = {}) {
    return new Promise(resolve => {
        let attemptsLeft = totalAttempts;
        const testAssertion = function (attemptsLeft) {
            if (debugLabel) console.log(`⏱ ${debugLabel}: executing waitForAssertion, attempts left:`, attemptsLeft);
            if (attemptsLeft < 1) {
                if (debugLabel) console.log(`⏱ ${debugLabel}: waitForAssertion failed: ran out of attempts`);
                resolve(false);
            }
            else if (assertionPredicateFn()) {
                if (debugLabel) console.log(`⏱ ${debugLabel}: waitForAssertion success`);
                resolve(true);
            } else {
                setTimeout(function () {
                    testAssertion(attemptsLeft - 1);
                }, totalWaitingTime / totalAttempts)
            }
        }
        testAssertion(attemptsLeft);
    })
}

export async function carouselifyYotpoReviews() {

    // Wait for all Yotpo widget instances to load
    const widgetInstances = [...document.querySelectorAll('.yotpo-widget-instance')];
    const widgetsHaveLoaded = await waitForAssertion(() => {
        return widgetInstances.every((instance) => instance.dataset.yotpoElementLoaded == 'true');
    }, { debugLabel: 'Yotpo widgets' });
    if (!widgetsHaveLoaded) return;

    const widget = document.querySelector('.yotpo-main-reviews-widget');
    widget.id = 'yotpo-reviews-carouselified';

    // Wait for main widget to load
    const mainWidgetHasLoaded = await waitForAssertion(() => {
        return widget.querySelector('.yotpo-empty-state') || widget.querySelector('.yotpo-star-rating');
    }, { debugLabel: 'Yotpo main widget' });
    if (!mainWidgetHasLoaded) return;

    // Handle empty widget
    const emptyState = widget.querySelector('.yotpo-empty-state');
    if (emptyState) {
        widget.classList.add('widget--empty');
        const borderMargin = widget.querySelector('.yotpo-border-margin');
        borderMargin.remove();
        return;
    }

    // Remove extraneous elements
    const headerfilterContainer = widget.querySelector('.yotpo-filters-container');
    const paginationContainer = widget.querySelector('.yotpo-reviews-pagination-container');
    const headerBorders = widget.querySelectorAll('.yotpo-review-border-smooth');
    const reviewVotesWrappers = widget.querySelectorAll('.yotpo-review-votes-wrapper');
    const reviewBorders = widget.querySelectorAll('.yotpo-review-border-smooth');

    headerfilterContainer.remove();
    paginationContainer.remove();
    for (const headerBorder of headerBorders) {
        headerBorder.remove();
    }
    for (const votesWrapper of reviewVotesWrappers) {
        votesWrapper.remove();
    }
    for (const reviewBorder of reviewBorders) {
        reviewBorder.remove();
    }

    // Modify header
    const headerWrapper = widget.querySelector('.yotpo-layout-header-wrapper');
    const headerStarRating = widget.querySelector('.yotpo-star-rating');
    const headerScore = widget.querySelector('.yotpo-bottom-line-score');
    const headerNumReviews = widget.querySelector('.yotpo-bottom-line-basic-text');

    headerWrapper.innerHTML = `<div class="reviews-bottomline"></div><div class="star-rating-bottomline"></div>`;
    const headerReviewsBottomline = headerWrapper.querySelector('.reviews-bottomline'); // new element
    const headerStarRatingBottomline = headerWrapper.querySelector('.star-rating-bottomline'); // new element
    headerReviewsBottomline.insertAdjacentElement('beforeend', headerNumReviews);
    headerStarRatingBottomline.insertAdjacentElement('beforeend', headerStarRating);
    headerStarRatingBottomline.insertAdjacentElement('beforeend', headerScore);
    headerScore.insertAdjacentText('beforeend', ' Average rating');

    // Modify LLM summary text
    const summaryText = widget.querySelector('.yotpo-paragraph-summary-text');
    summaryText.style.fontSize = null;
    summaryText.style.lineHeight = null;

    // Modify reviews
    const reviews = widget.querySelectorAll('.yotpo-review');

    for (const review of reviews) {
        review.style.width = null;
        // const leftPanel = review.querySelector('.yotpo-review-left-panel');
        // const centerPanel = review.querySelector('.yotpo-review-center-panel');
        const rightPanel = review.querySelector('.yotpo-review-right-panel');
        const title = review.querySelector('.yotpo-review-title');
        const customQuestions = review.querySelector('.yotpo-review-customer-questions-container');
        const reviewer = review.querySelector('.yotpo-reviewer');
        const reviewerName = review.querySelector('.yotpo-reviewer-name');
        reviewerName.textContent = reviewerName.getAttribute('title');
        reviewer.insertAdjacentElement('beforebegin', reviewerName);
        title.remove();
        reviewer.remove();
        while (rightPanel.firstChild) {
            rightPanel.lastChild.remove();
        }
        if (customQuestions) {
            rightPanel.insertAdjacentElement('beforeend', customQuestions);
        }

    }

    // Apply Glide classes
    const container = widget.querySelector('.yotpo-reviews-container');
    const list = widget.querySelector('.yotpo-reviews-list');
    const listWrapper = widget.querySelector('.yotpo-reviews-list-wrapper');
    list.insertAdjacentElement('beforebegin', listWrapper);
    list.remove();

    container.classList.add('glide');
    container.insertAdjacentHTML('afterbegin', `<div class='glide__track'></div>`);
    const glideTrack = container.querySelector('.glide__track');
    glideTrack.dataset.glideEl = 'track';
    glideTrack.insertAdjacentElement('beforeend', listWrapper);
    glideTrack.insertAdjacentHTML('afterend', `
        <div class="glide__arrows" data-glide-el="controls" role="group" aria-label="slide controls">
            <div class="yotpo-carousel-arrow glide__arrow glide__arrow--left arrow-clicked" data-glide-dir="&lt;" tabindex="0" role="button" aria-label="previous slide">
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <title>left arrow</title>
                <path d="M12.6652 14L18.3027 19.6375L16.6923 21.2479L9.44446 14L16.6923 6.75215L18.3027 8.36253L12.6652 14Z" fill="#272850"></path>
                </svg>
            </div>
            <div class="yotpo-carousel-arrow glide__arrow glide__arrow--right arrow-clicked" data-glide-dir="&gt;" tabindex="0" role="button" aria-label="next slide">
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <title>right arrow</title>
                <path d="M15.3348 14L9.69727 8.36246L11.3077 6.75208L18.5555 14L11.3077 21.2479L9.69727 19.6375L15.3348 14Z" fill="#272850"></path>
                </svg>
            </div>
        </div>
    `);
    listWrapper.classList.add('glide__slides');
    for (const review of reviews) {
        review.classList.add('glide__slide');
    }

    // Initialize Glide
    new Glide('.glide', {
        perView: 3,
        type: reviews.length >= 3 ? 'carousel' : 'slider',
        startAt: 0,
        autoplay: 6000,
        breakpoints: {
            // Glide breakpoints are @media (width < $x)
            768: {
                perView: 2,
                type: reviews.length >= 2 ? 'carousel' : 'slider',
            },
            480: {
                perView: 1,
                type: reviews.length >= 2 ? 'carousel' : 'slider',
            },
        }
    }).mount();
}
